function Aboutus() {
    return (
        <div className=" px-12 py-12 mt-12">
            <div className="text-center text-secondary text-5xl font-bold">About Us</div>
            <div className="text-center h-48 mt-6">/About us text here/</div>
            <div className="text-center text-secondary text-5xl font-bold">Introduction</div>
            <div className="grid grid-cols-2 gap-4 mt-6 justify-items-center">
                <div className="border border-gray-200 rounded-lg shadow-sm w-1/2 grid grid-cols-1">
                    <div className="h-72 w-full">
                        <img src='imgs/profile.jpg' className="rounded-t-lg w-full h-full object-cover" alt="tag" />
                    </div>
                    <div className="p-4">
                        <div className="font-bold text-center">Name</div>
                        <div>Text</div>
                    </div>
                </div>
                <div className="border border-gray-200 rounded-lg shadow-sm w-1/2">
                    <div className="h-72 w-full">
                        <img src='imgs/profile.jpg' className="rounded-t-lg w-full h-full object-cover" alt="tag" />
                    </div>
                    <div className="p-4">
                        <div className="font-bold text-center">Name</div>
                        <div>Text</div>
                    </div>
                </div>
            </div>
        </div>
    );
}


export default Aboutus;